import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CalendarDays, LogOut, User, Menu, X, LayoutDashboard } from "lucide-react";
import { useState } from "react";

export default function Navbar({ logo, shopName }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { label: "Serviços", href: "/#servicos" },
    { label: "Barbeiros", href: "/#barbeiros" },
    { label: "Localização", href: "/#localizacao" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-zinc-950/85 backdrop-blur-md border-b border-amber-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          {logo ? (
            <img src={logo} alt={shopName} className="h-10 w-auto object-contain" />
          ) : (
            <span className="font-display text-xl gold-text font-bold">{shopName}</span>
          )}
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.label} href={l.href} className="text-sm font-medium text-zinc-300 hover:text-amber-400 transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase()}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button variant="ghost" className="text-zinc-300 hover:text-amber-400" onClick={() => nav("/admin")} data-testid="nav-admin-btn">
                  <LayoutDashboard className="w-4 h-4 mr-2" /> Painel
                </Button>
              )}
              <Button variant="ghost" className="text-zinc-300 hover:text-amber-400" onClick={() => nav("/meus-agendamentos")} data-testid="nav-my-appointments-btn">
                <CalendarDays className="w-4 h-4 mr-2" /> Meus Horários
              </Button>
              <Button variant="ghost" size="icon" className="text-zinc-400 hover:text-red-400" onClick={() => { logout(); nav("/"); }} data-testid="nav-logout-btn">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button variant="ghost" className="text-zinc-300 hover:text-amber-400" onClick={() => nav("/login")} data-testid="nav-login-btn">
              <User className="w-4 h-4 mr-2" /> Entrar
            </Button>
          )}
          <Button className="bg-gradient-to-r from-amber-400 to-yellow-600 text-black font-bold rounded-full hover:brightness-110" onClick={() => nav("/agendar")} data-testid="nav-book-btn">
            Agendar
          </Button>
        </div>

        <button className="md:hidden text-zinc-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-amber-500/10 bg-zinc-950 px-4 py-4 space-y-3">
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="block text-zinc-300 py-1" data-testid={`nav-mobile-${l.label.toLowerCase()}`}>{l.label}</a>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            {user ? (
              <>
                {user.role === "admin" && <Button variant="outline" onClick={() => nav("/admin")}>Painel Admin</Button>}
                <Button variant="outline" onClick={() => nav("/meus-agendamentos")}>Meus Horários</Button>
                <Button variant="ghost" onClick={() => { logout(); nav("/"); }}>Sair</Button>
              </>
            ) : (
              <Button variant="outline" onClick={() => nav("/login")}>Entrar</Button>
            )}
            <Button className="bg-gradient-to-r from-amber-400 to-yellow-600 text-black font-bold" onClick={() => nav("/agendar")}>Agendar Horário</Button>
          </div>
        </div>
      )}
    </header>
  );
}
